export default "__VITE_ASSET__nT4mIygZ__"